export default {"src":"/_next/static/media/train.4a860b86.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};